import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 73 72" {...props}><g opacity=".5"><path fillRule="evenodd" d="M36.5 66c-16.542 0-30-13.458-30-30s13.458-30 30-30 30 13.458 30 30-13.458 30-30 30" clipRule="evenodd" opacity=".4" /><path d="M24.5 30a6 6 0 016-6h12a6 6 0 016 6v12a6 6 0 01-6 6h-12a6 6 0 01-6-6z" /></g></svg>;